// Module
var code = "<react-component name=\"ManageWebsiteWidgets\" props=\"{save: save, websiteData: website, websiteUrl: websiteUrl(), mobileAppSettings: mobileAppSettings}\"></react-component>\n";
// Exports
module.exports = code;